import React, { useState, useCallback, useEffect, useRef } from "react";
import { connect } from "react-redux";
import "../css/omstyle.css";
import AccordionReact from 'devextreme-react/accordion';
import { GetFormatedDateWithTime } from '../../common/Utils'
import SelectBox from 'devextreme-react/select-box';
import TextBox from 'devextreme-react/text-box';
import data from "../../assets/apiRoutes.json";
import axios from "axios";
import { useHistory, useParams } from 'react-router-dom';
import DateBox from 'devextreme-react/date-box';
import ViewTransactionHistoryDetails from "./ViewTransactionHistoryDetails";
import { LoadPanel } from 'devextreme-react/load-panel';
import { fetchLookupData, fetchProfileLookupData } from '../services/OMService'
import { ABECASUSER_LOGIN_TYPE, CONSIGNEE_LOGIN_TYPE } from "../../common/permissions";
const panel = [
    {
        ID: 1,
        Title: 'Change Quote'
    }
];
const ViewTransactionHistory = (props) => {
    var accessToken = props.oidc.user.access_token;
    const [formData, setFormData] = useState({
        transactionnumber: "",
        transactionDate: "",
        shippingDate: "",
        shippernameto: "",
        rShipper: "",
        rShipperTo: "",
        shippernameto: "",
        reference: "",
        rCustomerFrom: "",
        rCustomerTo: "",
        customernamefrom: "",
        customernameto: "",
        identityId: "",
        stage: "Q",
        status: "O",
        module: "OM",
        transactionType: "I",
        recordtype: "R",
        rProfile: "",
        profileVal: "",
        rShipperVia: "",
        shippernameVia: ""
    });
    const {
    } = formData;
    const Profile = 4;
    const [transactionSelectedLookupData, setTransactionLookupSelectedData] = useState({});
    const [stage, setStage] = useState(props.selectedTab === "Quote" ? "Q" : "P");
    const [loadPanelVisible, setLoadPanelVisible] = useState(false);
    const [showIndicator, setShowIndicator] = useState(true);
    const [shading, setShading] = useState(true);
    const [showPane, setShowPane] = useState(true);
    const [hideOnOutsideClick, setHideOnOutsideClick] = useState(false);
    const today = new Date().toISOString().split('T')[0];
    const position = { of: '#accordion-containe2' };
    const [openLookupShipperTo, setOpenLookupShipperTo] = useState(false);
    const [searchPanelStatus, setSearchPanelStatus] = useState(true);
    const [transactionNumber, setTransactionNumber] = useState('');
    const [headerRowId, setHeaderRowId] = useState('');
    const [transDate, setTransDate] = useState(today);
    const [shipDate, setShipDate] = useState('');
    const [openLookupCustomer, setOpenLookupCustomer] = useState(false);
    const [disableAddDetailButton, setDisableAddDetailButton] = useState(true);
    const [openLookupProfile, setOpenLookupProfile] = useState(false);
    const [openLookupShippVia, setOpenLookupShippVia] = useState(false);
    const [selectedItems, setSelectedItems] = useState([panel[0]]);
    const [success, setSuccess] = useState(false);
    const [IsVisible, setIsVisible] = useState(true);
    const [IsDisable, setIsDisable] = useState(false);
    const [successMessage, setSuccessMessage] = useState('');
    const [error, setError] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [warning, setwarning] = useState(false);
    const [poNumber, setPoNumber] = useState('');
    const [warningMessage, setwarningMessage] = useState('');
    const history = useHistory();
    const lookups = {};
    ///ShipTo Lookup
    const SHIPPER_ID_TO = "shipperidto";
    lookups[SHIPPER_ID_TO] = {
        name: "ShipperTo",
        label: "Ship To:",
        lookupType: 5
    };
    const shipToLookupType = 5;
    const [selectedShipToValue, setSelectedShipToValue] = useState();
    const [selectedShipToData, setSelectedShipToData] = useState();
    const setShipTolookupData = (selectedValue) => {
        loadLookupData(selectedValue, shipToLookupType, setSelectedShipToData, setSelectedShipToValue);
    }
    const onShipToValueChanged = useCallback((e) => {
        setSelectedShipToValue(e.value);
        setFormData({
            ...formData,
            rShipperTo: e.value.rowid,
        })
    }, [lookups, setFormData]);
    ////////ShipTo Lookup///////////////////////
    ///ShipVia Lookup
    const SHIPPER_VIA = "shipperivia";
    lookups[SHIPPER_VIA] = {
        name: "ShipperVia",
        label: "Shipper Via:",
        lookupType: 4
    };
    const shipViaLookupType = 4;
    const [selectedShipViaValue, setSelectedShipViaValue] = useState();
    const [selectedShipViaData, setSelectedShipViaData] = useState();
    const setShipVialookupData = (selectedValue) => {
        loadLookupData(selectedValue, shipViaLookupType, setSelectedShipViaData, setSelectedShipViaValue);
    }
    const onShipViaValueChanged = useCallback((e) => {
        setSelectedShipViaValue(e.value);
        setFormData({
            ...formData,
            rShipperVia: e.value.rowid,
            shippernameVia: e.value.name,
        })
    }, [lookups, setFormData]);
    ////////ShipTo Lookup///////////////////////
    ///Customer Lookup
    const CUSTOMER_ID_FROM = "customeridfrom";
    lookups[CUSTOMER_ID_FROM] = {
        name: "CustomerFrom",
        label: "Customer:",
        lookupType: 3
    };
    const customerLookupType = 3;
    const [selectedcustomerValue, setSelectedcustomerValue] = useState();
    const [selectedcustomerData, setSelectedcustomerData] = useState();
    const setcustomerlookupData = (selectedValue) => {
        loadLookupData(selectedValue, customerLookupType, setSelectedcustomerData, setSelectedcustomerValue);
    }
    const oncustomerValueChanged = useCallback((e) => {
        setSelectedcustomerValue(e.value);
        setFormData({
            ...formData,
            rCustomerFrom: e.value.rowid,
            customernamefrom: e.value.name,
        })
    }, [lookups, setFormData]);
    //////////////////////////
    ///Profile Lookup
    const PROFILE = "profile";
    lookups[PROFILE] = {
        name: "Profile",
        label: "Profile Code:",
        lookupType: 4
    };
    const profileLookupType = 4;
    const [selectedprofileValue, setSelectedprofileValue] = useState();
    const [selectedprofileData, setSelectedprofileData] = useState();
    const setprofilelookupData = (selectedValue) => {
        loadLookupProfileData(selectedValue, profileLookupType, setSelectedprofileData, setSelectedprofileValue);
    }
    const onprofileValueChanged = useCallback((e) => {
        setSelectedprofileValue(e.value);
        setFormData({
            ...formData,
            rProfile: e.value.rowid,
            profileVal: e.value.code,
        })
    }, [lookups, setFormData]);
    //////////////////////////
    const loadLookupProfileData = useCallback(async (selectedValue, lookupType, setData, setValue) => {
        try {
            var result = await fetchProfileLookupData(selectedValue[0].code, lookupType, accessToken);
            setData(result);
            setValue(selectedValue[0]);
        } catch (error) {
            console.error("Error setting transaction lookup data:", error);
        }
    }, [fetchProfileLookupData]);
    const loadLookupData = useCallback(async (selectedValue, lookupType, setData, setValue) => {
        try {
            var result = await fetchLookupData(selectedValue[0].identityId, lookupType, accessToken);
            setData(result);
            setValue(selectedValue[0]);
        } catch (error) {
            console.error("Error setting transaction lookup data:", error);
        }
    }, [fetchLookupData]);
    const hideLoadPanel = useCallback(() => {
        setLoadPanelVisible(false);
    }, [setLoadPanelVisible]);

    const handelOpenLookupShipperTo = () => {
        setOpenLookupShipperTo(true);
    }
    const handelOpenLookupCustomer = () => {
        setOpenLookupCustomer(true);
    }
    const handelOpenLookupProfile = () => {
        setOpenLookupProfile(true);
    }
    const handelOpenLookupShippVia = () => {
        setOpenLookupShippVia(true);
    }
    const goBack = () => {
        history.goBack();
    };
    const onTransactionDateChange = useCallback(
        (e) => {
            setTransDate(e.value);
        },
        [setTransDate],
    );
    const onShippingDateChange = useCallback(
        (e) => {
            setShipDate(e.value);
        },
        [setShipDate],
    );
    const onPoNumberChange = useCallback(
        (e) => {
            
            setPoNumber(e.value);
        },
        [setPoNumber],
    );
    const mapToDto = (formData) => {
        return {
            Rowid: props.id,
            TransactionNumber: formData.transactionnumber,
            TransactionType: formData.transactionType,
            TransactionDate: GetFormatedDateWithTime(transDate),
            ShippingDate: GetFormatedDateWithTime(shipDate),
            RShipper: formData.rShipper,
            RCustomer: formData.rCustomerFrom,
            RShipVia: formData.rShipperVia,
            PoNumber: poNumber,
            Stage: stage,
            Status: formData.status,
            Module: formData.module,
            RecordType: formData.recordtype,
            RProfile: formData.rProfile,
        };
    };
    const selectionChanged = useCallback(
        (e) => {
            let newItems = [...selectedItems];
            e.removedItems.forEach((item) => {
                const index = newItems.indexOf(item);
                if (index >= 0) {
                    newItems.splice(index, 1);
                }
            });
            if (e.addedItems.length) {
                newItems = [...newItems, ...e.addedItems];
            }
            setSelectedItems(newItems);
            setSearchPanelStatus((prevStatus) => {
                const newStatus = !prevStatus;
                return newStatus;
            });
        },
        [selectedItems, setSelectedItems],
    );
    const GetHeaderInfoById = async (id) => {
        try {
            const response = await axios.get(`${window._env_.REACT_APP_APIS}/${data.OM.GetHeaderById}?id=${id}`, {
                headers: {
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`
                }
            });
            const responseData = response.data;
            if (responseData.success) {
                setTransactionNumber(responseData.data.transactionnumber);
                setTransDate(responseData.data.transactiondate);
                setShipDate(responseData.data.shippingDate);
                setPoNumber(responseData.data.ponumber);
                const shiptoIdentityId = responseData.data.shiptoIdentityId;
                const trimmedShiptoIdentityId = shiptoIdentityId ? shiptoIdentityId.trim() : '';
                if (trimmedShiptoIdentityId != null || trimmedShiptoIdentityId == undefined) {
                    const shipToObj = [{
                        "identityId": trimmedShiptoIdentityId,
                        "rowid": responseData.data.rShipper,
                        "name": responseData.data.shiptoname,
                    }];
                    loadLookupData(shipToObj, shipToLookupType, setSelectedShipToData, setSelectedShipToValue);
                }
                const shipviaIdentityId = responseData.data.shipviaIdentityId;
                const trimmedshipviaIdentityId = shipviaIdentityId ? shipviaIdentityId.trim() : '';
                if (trimmedshipviaIdentityId != null || trimmedshipviaIdentityId == undefined) {
                    const shipViaObj = [{
                        "identityId": trimmedshipviaIdentityId,
                        "rowid": responseData.data.rShipVia,
                        "name": responseData.data.shipvianame,
                    }];
                    loadLookupData(shipViaObj, shipViaLookupType, setSelectedShipViaData, setSelectedShipViaValue);
                }

                const customerIdentityId = responseData.data.customerIdentityId;
                const trimmedcustomerIdentityId = customerIdentityId ? customerIdentityId.trim() : '';
                if (trimmedcustomerIdentityId != null || trimmedcustomerIdentityId == undefined) {
                    const CustomerObj = [{
                        "identityId": trimmedcustomerIdentityId,
                        "rowid": responseData.data.rCustomer,
                        "name": responseData.data.CustomeName,
                    }];
                    loadLookupData(CustomerObj, customerLookupType, setSelectedcustomerData, setSelectedcustomerValue);
                }

                const profileCode = responseData.data.profileCode;
                const trimmedprofileCode = profileCode ? profileCode.trim() : '';
                if (trimmedprofileCode != null || trimmedprofileCode == undefined) {
                    const ProfileObj = [{
                        "identityId": trimmedprofileCode,
                        "code": trimmedprofileCode,
                        "rowid": responseData.data.rProfile,
                    }];
                    loadLookupProfileData(ProfileObj, profileLookupType, setSelectedprofileData, setSelectedprofileValue);
                }

            } else {
                console.error('Failed to get item detail:', responseData.message);
            }
        } catch (error) {
            console.error('Error fetching item detail:', error);
        } finally {

        }
    };
    useEffect(() => {
        GetHeaderInfoById(props.id);
    }, []);
    return (
        <div>

            <div className="row">
                <div className="col-md-12 main-page">
                    <div id="accordion" >
                        <LoadPanel
                            shadingColor="rgba(0,0,0,0.4)"
                            position={position}
                            onHiding={hideLoadPanel}
                            visible={loadPanelVisible}
                            showIndicator={showIndicator}
                            shading={shading}
                            showPane={showPane}
                            hideOnOutsideClick={hideOnOutsideClick}
                        />
                        <AccordionReact
                            dataSource={panel}
                            collapsible={true}
                            multiple={false}
                            animationDuration={300}
                            selectedItems={selectedItems}
                            onSelectionChanged={e => {
                                if (e.currentTarget === e.target) {
                                    selectionChanged(e, e.target);
                                }
                            }}
                            itemTitleRender={() => (
                                <div className="header" >
                                    <div className="title" >
                                        <h6
                                            style={{
                                                marginLeft: "0px",
                                                marginBottom: "0",
                                                color: window._env_.Color2,
                                                fontWeight: "700",
                                            }}
                                        >
                                            View Details
                                        </h6>
                                    </div>
                                    <div className="buttons-container">
                                        <button
                                            className="ResetButtonStyle"
                                            type="button" onClick={goBack}
                                        >
                                            Back{" "}
                                        </button>
                                    </div>
                                </div>
                            )}
                            itemRender={(itemProps) => (
                                <div style={{ height: '110px', overflowY: 'auto' }}>
                                    <div className="row">
                                        <div className="col-md-3">
                                            <TextBox
                                                className="light-ui-textbox"
                                                labelMode="static"
                                                label="Trans #"
                                                defaultValue=""
                                                style={{ width: '100%' }}
                                                value={transactionNumber}
                                                readOnly={true}
                                            />

                                        </div>
                                        <div className="col-md-3">
                                            <DateBox
                                                label="Transaction Date:"
                                                defaultValue=''
                                                type="date"
                                                value={transDate}
                                                onValueChanged={onTransactionDateChange}
                                                readOnly={true}
                                                className="light-ui-textbox"
                                                labelMode="static"
                                            />
                                        </div>
                                        <div className="col-md-3">
                                            <DateBox
                                                label="Shipping Date:"
                                                defaultValue=''
                                                type="date"
                                                value={shipDate}
                                                onValueChanged={onShippingDateChange}
                                                readOnly={true}
                                                className="light-ui-textbox"
                                                labelMode="static"
                                            />
                                        </div>
                                        <div className="col-md-3 d-flex align-items-center">
                                            <SelectBox
                                                dataSource={selectedShipViaData}
                                                displayExpr="identityId"
                                                searchEnabled={true}
                                                label="Shipper Via"
                                                onValueChanged={onShipViaValueChanged}
                                                value={selectedShipViaValue}
                                                defaultValue={selectedShipViaValue}
                                                readOnly={true}
                                                className="light-ui-textbox"
                                                labelMode="static"
                                            />
                                        </div>
                                    </div>
                                    <div className="row" style={{ paddingTop: "10px" }}>
                                    <div className="col-md-3">
                                            <SelectBox
                                                dataSource={selectedShipToData}
                                                displayExpr="identityId"
                                                searchEnabled={true}
                                                label="Ship To"
                                                onValueChanged={onShipToValueChanged}
                                                value={selectedShipToValue}
                                                readOnly={true}
                                                className="light-ui-textbox"
                                                labelMode="static"
                                            />
                                        </div>
                                        <div className="col-md-3">
                                            <TextBox
                                                className="light-ui-textbox"
                                                labelMode="static"
                                                label="PO Number:"
                                                defaultValue=""
                                                style={{ width: '100%' }}
                                                value={poNumber}
                                                onValueChanged={onPoNumberChange}
                                                readOnly={true}
                                            />
                                        </div>
                                        {props.oidc.user.profile.hasOwnProperty("LOGINTYPEID") && (props.oidc.user.profile.LOGINTYPEID === ABECASUSER_LOGIN_TYPE || props.oidc.user.profile.LOGINTYPEID === CONSIGNEE_LOGIN_TYPE) && (
                                        <div className="col-md-3">
                                            <SelectBox
                                                dataSource={selectedcustomerData}
                                                displayExpr="identityId"
                                                searchEnabled={true}
                                                label="Customer"
                                                onValueChanged={oncustomerValueChanged}
                                                value={selectedcustomerValue}
                                                defaultValue={selectedcustomerValue}
                                                readOnly={true}
                                                className="light-ui-textbox"
                                                labelMode="static"
                                            />
                                             
                                        </div>
                                         )}
                                        {props.oidc.user.profile.hasOwnProperty("LOGINTYPEID") && props.oidc.user.profile.LOGINTYPEID === ABECASUSER_LOGIN_TYPE && (
                                        <div className="col-md-3 d-flex align-items-center">
                                            <SelectBox
                                                dataSource={selectedprofileData}
                                                displayExpr="code"
                                                searchEnabled={true}
                                                label="Profile"
                                                onValueChanged={onprofileValueChanged}
                                                value={selectedprofileValue}
                                                defaultValue={selectedprofileValue}
                                                readOnly={true}
                                                className="light-ui-textbox"
                                                labelMode="static"
                                            />
                                        </div>
                                         )}
                                    </div>
                                </div>
                            )}
                            id="accordion-container" className="accordion-height"
                        />
                         <ViewTransactionHistoryDetails
                            searchPanelStatus={searchPanelStatus}
                            setDisableAddDetailButton={setDisableAddDetailButton}
                            headerRowId={props.id}
                            disableAddDetailButton={false}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(ViewTransactionHistory);